import { render, staticRenderFns } from "./RebalanceSummary.vue?vue&type=template&id=4f85204d&scoped=true&"
import script from "./RebalanceSummary.vue?vue&type=script&lang=js&"
export * from "./RebalanceSummary.vue?vue&type=script&lang=js&"
import style0 from "./RebalanceSummary.vue?vue&type=style&index=0&id=4f85204d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f85204d",
  null
  
)

export default component.exports